import React from 'react';

import ContentLoader from 'react-content-loader';

import { Panel } from 'reaxl';

function BuildAndPriceModelPlaceholder({ ...rest }) {
    return (
        <Panel
            data-cmp="inventoryListingPlaceholder"
            {...rest}
        >
            <Panel.Body className="padding-bottom-1 padding-left-2 padding-top-2 padding-right-2">
                <ContentLoader
                    speed={2}
                    height="70"
                    backgroundColor="#e1e4e8"
                    foregroundColor="#f8f8f8"
                    style={{ width: '100%' }}
                >
                    <rect
                        x="0"
                        y="0"
                        width="160"
                        height="70"
                    />
                    <rect
                        x="165"
                        y="0"
                        width="100%"
                        height="10"
                    />
                    <rect
                        x="165"
                        y="20"
                        width="90"
                        height="5"
                    />
                    <rect
                        x="165"
                        y="30"
                        width="90"
                        height="5"
                    />
                    <rect
                        x="165"
                        y="40"
                        width="90"
                        height="5"
                    />
                </ContentLoader>
            </Panel.Body>
        </Panel>
    );
}
export default BuildAndPriceModelPlaceholder;
